const ArrowDiagonalRed = ({ fill = "#ED3A56", size = 16 }) => (
  <svg
    height={size}
    width={size}
    fill="none"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.3125 1.44754V11.6286C15.3125 12.0318 14.9854 12.358 14.5812 12.358C14.177 12.358 13.85 12.0318 13.85 11.6286V3.21201L1.93509 15.0982C1.79295 15.2396 1.60557 15.3125 1.41864 15.3125C1.23171 15.3125 1.04442 15.2413 0.901735 15.0988C0.616088 14.8138 0.616088 14.3519 0.901735 14.0674L12.8258 2.17211L4.34321 2.14682C3.93736 2.14512 3.61104 1.81685 3.61241 1.41563C3.61384 1.0124 3.94093 0.6875 4.34366 0.6875L14.5812 0.717418C14.988 0.719871 15.3125 1.04632 15.3125 1.44754Z"
      fill={fill}
    />
  </svg>
);

export default ArrowDiagonalRed;
